import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { SHARED_I18N_NAMESPACE, sharedEnUS } from "@jasper/shared";

i18n.use(initReactI18next).init({
  lng: "en-US",
  resources: {
    "en-US": { [SHARED_I18N_NAMESPACE]: sharedEnUS },
  },
  interpolation: {
    escapeValue: false,
  },
});
